(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6632],{

/***/ 68850:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./components/common/Layout/index.js + 26 modules
var Layout = __webpack_require__(19738);
// EXTERNAL MODULE: ./components/templates/offshore/guide-and-tool/company-name-check/index.js + 1 modules
var company_name_check = __webpack_require__(9570);
;// CONCATENATED MODULE: ./pages/sg/guide-and-tool/singapore-company-name-check/data.json
var data_namespaceObject = JSON.parse('{"breadcrumbs":[{"title":"Home","uri":"/"},{"title":"Guide & Tool","uri":"/guide-and-tool"},{"title":"Singapore Company Name Check"}],"banner":{"title":"Singapore Company Name Check"},"dataHowItWork":[{"content":"Search the company registrar of your given incorporation country"},{"content":"Check if your desired name can be reserved or was already in use"},{"content":"Inform you about the name check result"},{"content":"Decide to reserve the name (if available) or proceed with the company formation now"}],"dataFaqs":[{"name":"Does my entity name need to be unique?","content":"<p>Yes. Every entity must be attached to an identical business name. Your proposed name shall be rejected by the Company Registrar if it is found to be similar to other existing names in that jurisdiction of registration.</p>"},{"name":"What are the requirements for naming a new company?","content":"<div><p>Naming requirements for registering an LLC can be varied according to each jurisdiction. Typically, the following criteria are applied widely in most incorporation countries:</p><ul><li>The name should not be the same as the name of other companies</li><li>The name should not show offensive meaning or be opposed to the public interest as per the opinion of the Registrar</li><li>The name should not contain in its name restricted words/expressions as prescribed in the company laws</li></ul><p>The name must have suffixes corresponding to its type of business entity – i.e., “Limited” or its abbreviation “Ltd” for a limited liability company.</p></div>"},{"name":"If I want extra protection for my business name, what should I do?","content":"<p>Trademark registration for your business name is a good choice if you want to add a stronger layer of protection to your registered company name.</p>"},{"name":"What should I do if my desired company name is not available?","content":"<p>You can try another entity name using our Free Entity Name Check to see if it is available. In case you need more practical advice on how to choose an eligible name, you can also <a class=\\"text-bbc-primary\\" href=\\"javascript:void(Tawk_API.toggle())\\">talk to our consultants </a>for help.</p>"}]}');
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./pages/sg/guide-and-tool/singapore-company-name-check/index.js




var __N_SSG = true;
function Home(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Layout/* default */.Z, {
      locationRouter: "sg",
      page: data.page,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(company_name_check/* default */.Z, {
        dataJson: data_namespaceObject,
        data: data
      })
    })
  });
}

/***/ }),

/***/ 53778:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sg/guide-and-tool/singapore-company-name-check",
      function () {
        return __webpack_require__(68850);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,3105,9593,9885,9973,9669,6859,4090,9738,7447,9156,9570,2888,179], function() { return __webpack_exec__(53778); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);